import { useTranslation } from 'react-i18next';

import styles from './ChartLegend.module.scss';

export const ChartLegend = () => {
  const { t } = useTranslation('earnings');

  return (
    <div className={styles.chartLegendRoot}>
      <div className={styles.legendItem}>
        <div className={styles.legendIcon}>
          <div className={styles.miniBar} />
        </div>
        <span className={styles.legendLabel}>
          {t('earnings:chart.tradingRange')}
        </span>
      </div>
      <div className={styles.legendItem}>
        <div className={styles.legendIcon}>
          <div className={styles.miniCircle} />
        </div>
        <span className={styles.legendLabel}>{t('earnings:chart.median')}</span>
      </div>
    </div>
  );
};
